/* global axios */
import ApiClient from './ApiClient';

class LiveReportsAPI extends ApiClient {
  constructor() {
    super('live_reports', { accountScoped: true, apiVersion: 'v2' });
  }

  getConversationMetric(params = {}) {
    return axios.get(`${this.url}/conversation_metrics`, {
      params: {
        ...params,
        team_id: params.teamId ?? params.team_id,
      },
    });
  }

  getConversationActivity(params = {}) {
    return axios.get(`${this.url}/conversation_activity`, {
      params: {
        ...params,
        team_id: params.teamId ?? params.team_id,
      },
    });
  }

  getGroupedConversations({ groupBy } = { groupBy: 'assignee_id' }) {
    return axios.get(`${this.url}/grouped_conversation_metrics`, {
      params: { group_by: groupBy },
    });
  }

  getConversations({ metric, teamId, minutes, page = 1, signal } = {}) {
    return axios.get(`${this.url}/conversations`, {
      params: {
        metric,
        team_id: teamId,
        minutes,
        page,
      },
      signal,
    });
  }
}

export default new LiveReportsAPI();
